import React from 'react';
import Hero from './Hero';
import TrustBar from './TrustBar';
import TravelSection from './TravelSection';
import TopDestinations from './TopDestination';
import Activities from './Activities';
import PremiumDeals from './PremiumDeals';
import CielGoSection from './CielGoSection';

const Home = () => {
  return (
    <>
      <Hero />
      <TrustBar />
      <TravelSection />
      <TopDestinations />
      <Activities />
      <PremiumDeals />
      <CielGoSection />
    </>
  );
};

export default Home;
